import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWpengineComponent } from './simple-icons-wpengine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWpengineComponent ],
    exports:      [ SimpleIconsWpengineComponent ],
    bootstrap:    []
})
export class SimpleIconsWpengineModule {}
